import digitalIcon from '../assets/digitalIcon.png';
import textIcon from '../assets/textIcon.png';
import picIcon from '../assets/picIcon.png';
import videoIcon from '../assets/videoIcon.png';

export const navList = [
    {
        title: '视频',
        desc: '一键生成营销视频',
        width: 283,
        icon: videoIcon
    },
    {
        title: '图片',
        desc: '优质图片一键生成',
        width: 283,
        icon: picIcon
    },
    {
        title: '文案',
        desc: '多类型场景文案生成',
        width: 298,
        icon: textIcon
    },
    {
        title: '数字人',
        desc: '形象、语音高质量复刻',
        width: 315,
        icon: digitalIcon
    }
];

export const contentList = [
    {
        title: '视频',
        desc: '国内领先的AIGC生产技术。输入视频素材，对素材进行深度理解，融合丰富的后期制作，短时间生成高质量营销成片',
        wiseDesc: '国内领先AIGC技术。丰富的数字人模特+专属行业模板等，3分钟实现口播视频制作',
        video: 'https://qiaojiang.bj.bcebos.com/fe/static/video/home-video-v2.mp4',
        authorizedRole: 'digital_education_image',
        routeName: 'digitalConsole',
        buttonList: [
            {
                text: '一键成片',
                hideRole: 'digital_is_passport',
                authorizedRole: 'digital_human_list',
                routeName: 'MashupCreateV2'
            },
            {
                text: '专业编辑器',
                authorizedRole: 'digital_human_list',
                routeName: 'VideoTemplateV2'
            }
        ]
    },
    {
        title: '图片',
        desc: '支持营销海报制作及丰富的内容资产，精准满足广告主诉求，打造超级广告图片创作工具',
        wiseDesc: '支持文图生成和海报制作等能力，精准满足广告主诉求。实现AIGC营销场景的完美结合',
        video: 'https://qiaojiang.bj.bcebos.com/fe/static/video/home-image-v2.mp4',
        hideRole: 'digital_is_passport',
        authorizedRole: 'digital_human_list',
        routeName: 'imageCreateWork',
        buttonList: [
            {
                text: '一键生图',
                routeName: 'marketImageCreateNew'
            }, {
                text: '智能扩图',
                routeName: 'aiExpandImage'
            }
        ]
    },
    {
        title: '文案',
        desc: '基于百度强大AI能力，专注营销广告领域，覆盖信息流、搜索等多场景，以丰富、开放的方式满足文案定制需求',
        wiseDesc: '专注营销广告领域，覆盖信息流、搜索等场景。以丰富、开放的方式满足文案定制需求',
        video: 'https://qiaojiang.bj.bcebos.com/fe/static/video/home-text-v2.mp4',
        hideRole: 'digital_is_passport',
        authorizedRole: 'digital_human_list',
        routeName: 'textCreateWork',
        buttonList: [
            {
                text: '搜索广告文案',
                routeName: 'textCreateFc'
            }, {
                text: '信息流广告文案',
                routeName: 'textCreateFeed'
            }
        ]
    },
    {
        title: '数字人',
        desc: '基于AI模型能力，1:1还原形象和语音的复刻，支撑高品质内容输出，提高内容创作效率',
        wiseDesc: '国内领先AIGC技术。丰富的数字人模特+专属行业模板等，3分钟实现口播视频制作',
        video: 'https://qiaojiang.bj.bcebos.com/fe/static/video/home-digital-v2.mp4',
        authorizedRole: 'digital_human_list',
        routeName: 'digitalConsole',
        buttonList: [
            {
                text: '形象定制',
                routeName: 'HumanCreateV2'
            }, {
                text: '语音复刻',
                routeName: 'VoiceCreateV2'
            }
        ]
    }
];